import { axios } from 'api'
import React, { useEffect } from 'react'
import { useParams } from 'react-router-dom'
import CategoryView from 'components_v2/SupportPages/CategoryView'
import { useCommonEntryContext } from 'components_v2/common'
import { useMeta, useTitle } from 'hooks/useMetaTitle'
import { SUPPORT_DESCRIPTION } from './SupportView'

const SupportDetails = () => {
  const { category } = useParams()
  const { globalState, setGlobalState, setNotFound } = useCommonEntryContext()
  const key = `support_details_${category}`
  const props = globalState?.[key]
  useTitle('FAQ')
  useMeta([
    {
      name: 'description',
      content: SUPPORT_DESCRIPTION
    }
  ])
  useEffect(() => {
    if (props) return
    axios
      .get(`/support/list?category=${category}`)
      .then((res) => {
        setGlobalState(key, res.data?.list)
      })
      .catch((err) => {
        setNotFound(true)
        console.log(err)
      })
  }, [category, setGlobalState, key, props, setNotFound])
  if (!props) return null
  return <CategoryView articleList={props} category={category} />
}

export default SupportDetails
